
import { defineComponent } from 'vue';
import { moaOverviewComposition } from '../services';

export default defineComponent({
	setup() {
		return { ...moaOverviewComposition() }
	},
})
